module.exports = __webpack_public_path__ + "static/media/9.810feaf6.png";